import { db } from "./firebase"; 
import { addDoc, collection, serverTimestamp } from "firebase/firestore";

// Log page visit
export const logPageVisit = async (email, path) => {
  try {
    await addDoc(collection(db, "user_logs"), {
      event: "page_view",
      email,
      path,
      visited_at: serverTimestamp(),
      session_id: crypto.randomUUID(),
    });
  } catch (error) {
    console.error("Error logging page visit:", error);
  }
};
